import { NgModule } from '@angular/core';
import { moduleConfigFunc, TnxSharedModule } from 'tnx-shared';
import { OrganizationFormComponent } from './organization-form/organization-form.component';
import { OrganizationComponent } from './organization.component';
import { OrganizationRoutes } from './organization.routing';

export function declaration() {
    return [OrganizationComponent, OrganizationFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class OrganizationModule {
    static forRoot(config?: any): any {
        return {
            ngModule: TnxSharedModule,
            providers: [
                {
                    provide: moduleConfigFunc,
                    useValue: config
                }
            ]
        };
    }
}

@NgModule({
    imports: [OrganizationModule, OrganizationRoutes],
    exports: [OrganizationModule]
})
export class OrganizationWithRouteModule {
    static forRoot(config?: any): any {
        return {
            ngModule: TnxSharedModule,
            providers: [
                {
                    provide: moduleConfigFunc,
                    useValue: config
                }
            ]
        };
    }
}
